import { render } from "./job-details.vue?vue&type=template&id=e04f9e6e"
import script from "./job-details.vue?vue&type=script&lang=js"
export * from "./job-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__